import NavigationHelper from '../../layers/navigation/navigationHelper'

import { connect } from 'react-redux'
import Component from './component'

export default connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)(Component)
